
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              About VJETAR, d.o.o.
            </h2>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              VJETAR, d.o.o. is a technology company based in Sinj, Croatia, dedicated to developing innovative applications that enhance digital security and user experience. Our flagship product, VJETAR VPN, represents our commitment to protecting online privacy and freedom.
            </p>
            <p className="text-lg text-slate-600 mb-6 leading-relaxed">
              We believe that everyone deserves the right to browse the internet securely and privately. Our VPN solution combines cutting-edge encryption technology with user-friendly design to provide comprehensive protection for individuals and businesses alike.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              With servers strategically located around the globe, VJETAR VPN ensures fast, reliable connections while maintaining the highest standards of security and privacy. Our mission is to make the internet a safer place for everyone.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#contact" 
                className="px-8 py-4 bg-cyan-500 text-white font-semibold rounded-lg hover:bg-cyan-600 transition-all duration-300 shadow-lg hover:shadow-xl text-center whitespace-nowrap cursor-pointer"
              >
                Contact Us
              </a>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/4c5ab3d53e43d13a2f6b9c50f548ff02.jpg"
              alt="VJETAR VPN Technology"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
